import type { CalendarControllerActions } from "./controller.ts";
import type { CalendarMode, CalendarState } from "./state.ts";
import type { WeekStart } from "../tasks/calendar-presentation.ts";

export interface CalendarEventActionCapabilities {
  state: CalendarState;
  openTask(id: string): void | Promise<void>;
  activateSlot(slot: HTMLElement): void | Promise<void>;
  activateDate(date: string): void | Promise<void>;
  scheduleAt(id: string, date: string, minute: number): void | Promise<void>;
  scheduleAllDay(id: string, date: string): void | Promise<void>;
  shiftTask(id: string, minutes: number): void | Promise<void>;
  resizeTask(id: string, minutes: number): void | Promise<void>;
  openLocatedTask(id: string): void | Promise<void>;
  persist(key: string, value: unknown): Promise<unknown>;
  render(): Promise<unknown>;
  refreshContext(): Promise<unknown>;
  focusFirstSlot(): void;
}

export function createCalendarEventActions(capabilities: CalendarEventActionCapabilities): CalendarControllerActions {
  const { state } = capabilities;
  return {
    openTask: capabilities.openTask,
    selectTask: async id => { state.schedulingTaskId = id; await capabilities.render(); capabilities.focusFirstSlot(); },
    cancelSelection: async () => { state.schedulingTaskId = null; await capabilities.render(); },
    activateSlot: capabilities.activateSlot,
    activateDate: capabilities.activateDate,
    scheduleAt: capabilities.scheduleAt,
    scheduleAllDay: capabilities.scheduleAllDay,
    shiftTask: capabilities.shiftTask,
    resizeTask: capabilities.resizeTask,
    openLocatedTask: capabilities.openLocatedTask,
    setMode: async mode => { state.mode = mode as CalendarMode; await capabilities.persist("calendarMode", state.mode); await capabilities.refreshContext(); },
    setWeekStart: async start => { state.weekStart = start as WeekStart; await capabilities.persist("calendarWeekStart", state.weekStart); await capabilities.render(); },
    toggleWeekNumbers: async () => { state.weekNumbers = !state.weekNumbers; await capabilities.persist("calendarWeekNumbers", state.weekNumbers); await capabilities.render(); },
    toggleRecurrenceProjections: async () => { state.recurrenceProjections = !state.recurrenceProjections; await capabilities.persist("calendarRecurrenceProjections", state.recurrenceProjections); await capabilities.render(); },
    toggleExternalContext: async () => { state.contextEnabled = !state.contextEnabled; await capabilities.persist("externalCalendarContextEnabled", state.contextEnabled); await capabilities.refreshContext(); },
  };
}
